import React from "react";
import { CustomModal } from "@services/ui-components";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { useEnableOnlineBookingWithDeps } from "./utils/useEnableOnlineBookingWithDeps";
import { useParams } from "react-router-dom";
import { useUpdateModules } from "./utils/useUpdateModules";
import { useGetCompanyModulesQuery } from "@me-team/host/main/company/graphql/company.hooks";

interface AddPreTrainingModuleModalProps {
    show: boolean;
    onClose: () => void;
    toggleOpenConnectModal: () => void;
    companyId: number;
    moduleListRefetch?: ReturnType<typeof useGetCompanyModulesQuery>["refetch"];
}

const AddPreTrainingModuleModal: React.FC<AddPreTrainingModuleModalProps> = ({
    show,
    onClose,
    toggleOpenConnectModal,
    companyId,
    moduleListRefetch,
}) => {
    const { t } = useTranslation();
    const { branchId } = useParams();

    const updateModules = useUpdateModules();

    const {
        enableWithDependencies,
        onlineBookingModule,
        loading: enabling,
    } = useEnableOnlineBookingWithDeps({
        companyId,
        branchId: Number(branchId),
        updateModules,
    });

    const alreadyEnabled = onlineBookingModule?.active ?? false;

    const handleEnableOnlineBookingModule = async () => {
        try {
            await enableWithDependencies();
            await moduleListRefetch?.();
            toggleOpenConnectModal();
            onClose();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <CustomModal
            show={show}
            handleClose={onClose}
            headerAlignment="center"
            title={t("Connect the Online Booking module")}
            body={
                <Container>
                    <Row className="mb-3">
                        <Col>
                            <p className="mb-0">{t('To proceed, enable the free "Online Booking" module')}</p>
                        </Col>
                    </Row>
                </Container>
            }
            buttons={[
                {
                    text: t("Cancel"),
                    onClick: onClose,
                    variant: "outline-primary",
                    className: "w-100 fw-normal",
                    disabled: enabling,
                },
                {
                    text: t("Connect"),
                    onClick: handleEnableOnlineBookingModule,
                    variant: "primary",
                    className: "w-100 fw-normal",
                    disabled: alreadyEnabled || enabling,
                },
            ]}
        />
    );
};

export default AddPreTrainingModuleModal;
